import React from "react";
import { useFunctiesContext } from "./Context/FunctiesContext";
import { CardBody, Card } from "reactstrap";
import Loader from "react-loaders";

export default function Screen({ children }) {
	const { isLoading } = useFunctiesContext();
	return (
		<>
			{isLoading ? (
				<Card className="main-card">
					<CardBody className="d-flex flex-column">
						<Loader
							type="ball-grid-pulse"
							className={"mt-3 d-flex mx-auto justify-content-center"}
						/>
					</CardBody>
				</Card>
			) : (
				<>{children}</>
			)}
		</>
	);
}
